import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnDestroy, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator, MatPaginatorIntl, MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule, FormGroup, FormBuilder } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatOptionModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIcon, MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavContainer } from '@angular/material/sidenav';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { MatTableModule, MatRowDef } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICreateOfficeGroup } from './interfaces/create-office-group.interface';
import { OfficeGroupService } from './office-group.service';
import { IUpdateOfficeGroup } from './interfaces/update-office-group.interface';
import OfficeGroupAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/office-group/office-group.entity';
import { CompanyService } from '../company/company.service.service';
import CompanyAttributes from '@albatrosdeveloper/ave-models-package/lib/schemas/configurations/company/company.entity';
import { MatTabsModule } from '@angular/material/tabs';
import { NgSelectComponent, NgSelectModule } from '@ng-select/ng-select';
import { CustomMatPaginatorIntl } from 'app/mock-api/common/customPaginatorIntl';
import { getCode } from "app/utils/method";
import { ExportService } from 'app/layout/export-overlay/export-overlay.service';
import { ExportDialogComponent } from 'app/layout/export-overlay/dialog/export-dialog.component';
import { ExportOptions } from 'app/layout/export-overlay/tasks/core/export-task.interfaces';
import { OfficeGroupExport } from './exports/office-group.export';
import { OFFICE_GROUP_TITLE } from './exports/office-group.constants';
import { Subscription } from 'rxjs';
import { SearchService } from 'app/layout/common/search-page/search-page.service';
import { FilterComponent } from 'app/common/components/filter/filter.component';
import { StatusFiltersComponent } from '../../filters/status-filters/status-filters.component';
import { ConfigurationFiltersComponent } from '../../filters/configuration-filters/configuration-filters.component';
import { IFilters } from '../../filters/interfaces/filterInterface';
import { HoverMenuDirective } from "@fuse/directives/hover-menu/hover-menu.directive";
import { FormSectionComponent } from 'app/shared/components/form-ui/form-section/form-section.component';


@Component({
  selector: 'app-office-group',
  standalone:true,
  templateUrl: './office-group.component.html',
  styleUrl: './office-group.component.scss',
  imports: [
    CommonModule,
    MatTableModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSortModule,
    MatPaginatorModule,
    MatIcon,
    MatSlideToggle,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatExpansionModule,
    MatMenuModule,
    MatButtonModule,
    MatIconModule,
    MatRowDef,
    MatSidenavContainer,
    FormsModule,
    NgSelectComponent,
    NgSelectModule,
    MatTabsModule,
    FilterComponent,
    StatusFiltersComponent,
    ConfigurationFiltersComponent,
    HoverMenuDirective,
    FormSectionComponent
  ],
  providers: [
    { provide: MatPaginatorIntl, useClass: CustomMatPaginatorIntl },
    OfficeGroupExport
  ],
})
export class OfficeGroupComponent implements AfterViewInit, OnDestroy {
  getCode = getCode;
  displayedColumns: string[] = ["name", "status", "actions"];
  currentCreateOfficeGroup: ICreateOfficeGroup = this.initializeCreateOfficeGroup();
  currentUpdateOfficeGroup: OfficeGroupAttributes | undefined;

  dataSource: OfficeGroupAttributes[] = [];
  companyList: CompanyAttributes[] = [];
  searchQuery: string = '';
  totalItems: number = 0;
  pageSize: number = 50;
  pageIndex: number = 1;
  dialogRefAdd: MatDialogRef<any>;
  dialogRefEdit:MatDialogRef<any>;

  @ViewChild("editModal") editModal!: TemplateRef<any>;
  @ViewChild("addModal") addModal!: TemplateRef<any>;
  @ViewChild("deleteDialog") deleteDialog!: TemplateRef<any>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild("searchInput") searchInput!: ElementRef;
  
  //BUSCADOR
  searchSubscription: Subscription;

  form: FormGroup;
  selectedStatuses: number[] = [];

  // Lazy loading
  loadFiltersData = false;
  private companiesLoaded = false;

  constructor(
    private readonly officegroupService: OfficeGroupService,
    private readonly companyService: CompanyService,
    private readonly searchService: SearchService,
    private dialog: MatDialog,
    private snackBar: MatSnackBar,
    private cdr: ChangeDetectorRef,
    public exportService: ExportService,
    private officeGroupExport: OfficeGroupExport,
    private fb: FormBuilder
  ) {
    this.form = this.fb.group({
      companyId: [null],
    });
  }

  ngAfterViewInit(): void {
    this.onHandleSearch();
    this.setupPaginationAndSorting();
    this.findAllWithCount();
  }

  private ensureCompaniesLoaded(): void {
    if (!this.companiesLoaded) {
      this.fetchCompanies();
    }
  }

  onFilterPanelOpened(): void {
    this.loadFiltersData = true;
    this.ensureCompaniesLoaded();
  }

  private fetchCompanies(): void {
    this.companyService.findToComboBox().subscribe({
      next: (res) => {
        this.companyList = res.data;
        this.companiesLoaded = true;
      },
      error: (err) => {
        this.snackBar.open(err.error.message || "Error al obtener compañias.","Cerrar",{ duration: 5000});
      },
    });
  }

  private initializeCreateOfficeGroup(): ICreateOfficeGroup {
    return { name: "", companyId:"" };
  }

  private setupPaginationAndSorting(): void {
    this.paginator.page.subscribe(() => this.findAllWithCount());
    this.sort.sortChange.subscribe(() => {
      this.paginator.pageIndex = 0;
      this.findAllWithCount();
    });
  }

  clearFilters(): void {
    this.searchQuery = "";
    this.form.reset({ companyId: null });
    this.findAllWithCount();
  }

  findAllWithCount(): void {
    // const pageIndex = this.paginator.pageIndex + 1;
    const sortField = this.getSortField();
    const sortDirection: "ASC" | "DESC" = this.sort.direction === "asc" ? "ASC" : "DESC";

    let filter: IFilters = {
      companyId: this.form.get('companyId')?.value,
      status: this.selectedStatuses.length > 0 ? this.selectedStatuses : undefined
    };
    this.officegroupService
      .findAllWithCount(
        { currentPage: this.pageIndex, limitPerPage: this.pageSize, search: this.searchQuery, sort: sortField, sortDirection: sortDirection },
        filter
      )
      .subscribe((data) => {
        this.dataSource = data?.data?.[0]?.data ?? [];
        this.totalItems = data?.data?.[0]?.pageInfo?.[0]?.total ?? 0;
        this.paginator.length = this.totalItems;
      });
  }

  private getSortField(): keyof OfficeGroupAttributes {
    const validSortFields: (keyof OfficeGroupAttributes)[] = ["name", "statusId"];
    return validSortFields.includes(this.sort.active as keyof OfficeGroupAttributes) ? (this.sort.active as keyof OfficeGroupAttributes) : "name";
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    this.pageIndex = event.pageIndex + 1;
    this.findAllWithCount();
  }

  onSearchChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.searchQuery = input.value.trim();
    if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
      // this.paginator.pageIndex = 0;
      this.findAllWithCount();
    }
  }

  public onHandleSearch(){
    this.searchSubscription = this.searchService.searchTerm$
      .subscribe(term => {
        this.searchQuery = term;
        if (this.searchQuery.length >= 2 || this.searchQuery.length === 0) {
          this.paginator.pageIndex = 0;
          this.findAllWithCount();
        }
      });
  }

  trackByFn(index: number, item: OfficeGroupAttributes): string {
    return item._id.toString();
  }

  openCreateModal(): void {
    this.ensureCompaniesLoaded();
    this.currentCreateOfficeGroup = this.initializeCreateOfficeGroup();
    this.dialogRefAdd = this.dialog.open(this.addModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefAdd.afterClosed().subscribe((result) => result && this.createOfficeGroup());
    this.dialogRefAdd.afterClosed().subscribe((result) => { result });
  }

  openEditModal(officegroup: OfficeGroupAttributes): void {
    this.ensureCompaniesLoaded();
    this.currentUpdateOfficeGroup = { ...officegroup };
    this.dialogRefEdit = this.dialog.open(this.editModal, {
      disableClose: true,
      width: '95%',
      maxWidth: '600px',
      maxHeight: '90vh'
    })
    // this.dialogRefEdit.afterClosed().subscribe((result) => result && this.updateOfficeGroup(officegroup._id.toString()));
    this.dialogRefEdit.afterClosed().subscribe((result) => { result });
  }

  createOfficeGroup(): void {
    this.officegroupService.create(this.currentCreateOfficeGroup).subscribe({
      next: () => {
        this.snackBar.open('Registro creado con éxito', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
        this.dialogRefAdd.close(true);
      },
      error: (err) => {
        this.snackBar.open(err.error.message || 'Error al crear el registro', 'Cerrar', { duration: 3000 });
      }
    });
  }

  updateOfficeGroup(id: string): void {
    if (this.currentUpdateOfficeGroup) {
      const updatedOfficeGroup: IUpdateOfficeGroup = { ...this.currentUpdateOfficeGroup,
        companyId: this.currentUpdateOfficeGroup.company._id.toString(),
       };

      this.officegroupService.update(id, updatedOfficeGroup).subscribe({
        next: () => {
          this.snackBar.open('Registro actualizado con éxito', 'Cerrar', { duration: 3000 });
          this.findAllWithCount();
          this.dialogRefEdit.close(true);
        },
        error: (err) => {
          this.snackBar.open(err.error.message || 'Error al actualizar el registro', 'Cerrar', { duration: 3000 });
        }
      });
    }
  }

  onStatusChange(event: boolean, officegroup: OfficeGroupAttributes): void {
    const originalStatusId = officegroup.statusId;
    const updatedStatusId = event ? 1 : 0;
    const updatedOfficeGroup = { ...officegroup, statusId: updatedStatusId };

    this.officegroupService.update(officegroup._id.toString(), updatedOfficeGroup).subscribe({
      next: () => {
        this.findAllWithCount();
      },
      error: () => {
        officegroup.statusId = originalStatusId; // Volver al estado original si falla
        this.snackBar.open('Error al actualizar el estado.', 'Cerrar', { duration: 3000 });
        this.findAllWithCount();
      }
    });
  }

  openDeleteDialog(officegroup: OfficeGroupAttributes): void {
    this.dialog
      .open(this.deleteDialog, { data: officegroup, disableClose:true })
      .afterClosed()
      .subscribe((result) => result && this.delete(officegroup._id.toString()));
  }

  delete(id: string): void {
    this.officegroupService.remove(id).subscribe(() => {
      this.findAllWithCount();
      this.snackBar.open('Registro eliminado con éxito', 'Cerrar', { duration: 3000 });
    });
  }
  onCompanySelectionChange(companyid: string): void {
    if (this.currentUpdateOfficeGroup) {
      this.currentUpdateOfficeGroup.company = this.companyList.find(
        (company) => company._id.toString() === companyid
      )!;
    }
    
  }

  
  compareById(item1: any, item2: any): boolean {
    return item1 && item2 ? item1._id === item2._id : item1 === item2;
  }

  //exportar
  onExportButtonPressed() {
    if (!this.officeGroupExport.canStartTask()) return;
    const dialogRef = this.dialog.open(ExportDialogComponent, {
      data: { title: OFFICE_GROUP_TITLE },
    });
    dialogRef.afterClosed().subscribe((options: ExportOptions) => {
      if (options) {
        this.officeGroupExport.export(
          options.format,
          options.range,
          this.totalItems,
          this.pageSize,
          this.pageIndex,
        );
      }
    });
  }

  ngOnDestroy(): void {
    this.searchSubscription.unsubscribe();
  }
}
